<template>
  <div
    class="s-filial-item"
    :class="{
      selected: selected,
      's-select-value': isSelectValue,
      's-list-item': isListItem,
    }"
  >
    <div class="s-filial-item__icon">
      <component :is="itemIcon" />
    </div>
    <div class="s-filial-item__content">
      <div class="s-filial-item__address">
        {{ item.name }}
      </div>
      <div class="s-filial-item__city">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
  import IconDefault from '@/components/ui/filial-with-presets/icons/IconDefault'
  import IconFilialFranchise from '@/components/ui/filial-with-presets/icons/IconFilialFranchise'
  import IconPresetAll from '@/components/ui/filial-with-presets/icons/IconPresetAll'
  import IconPresetOwn from '@/components/ui/filial-with-presets/icons/IconPresetOwn'
  import IconPresetFranchise from '@/components/ui/filial-with-presets/icons/IconPresetFranchise'
  import IconOwnFilial from '@/components/icons/filial/IconOwnFilial'
  import IconFranchiseFilial from '@/components/icons/filial/IconFranchiseFilial'
  import IconDeactivatedFilial from '@/components/icons/filial/IconDeactivatedFilial.vue'

  export default {
    name: 'FilialSelectWithPresetsItem',
    components: {
      IconPresetFranchise,
      IconPresetOwn,
      IconPresetAll,
      IconFilialFranchise,
      IconDefault,
      IconFranchiseFilial,
      IconDeactivatedFilial,
      IconOwnFilial,
    },
    props: {
      item: Object,
      selected: Boolean, // выбранный в списке
      isSelectValue: Boolean,
      isListItem: Boolean,
    },
    computed: {
      itemIcon () {
        if (this.item.icon) {
          return `icon-${this.item.icon}`
        }
        return 'icon-default'
      },
    },
  }
</script>

<style lang="less" scoped>
.s-filial-item {
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
  overflow: hidden;

  /*&:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: red;
  }*/

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    min-width: 25px;
    svg {
      color: #C4CDD9;
      transition: 0.1s ease;
    }

  }

  &__content {
    line-height: 1.3;
    color: #000;
  }

  &__address {
    white-space: nowrap;
    //margin-bottom: 2px;
    text-overflow: ellipsis;
    padding-right: 5px;
    overflow: hidden;
  }

  &__city {
    color: #C4CDD9;
    white-space: nowrap;
  }

  &:hover,
  &.selected {
    .s-filial-item__icon {
      svg {
        color: #FF9100;
      }
    }
  }

  &.s-list-item {
    width: 100%;
    padding: 0 16px;
    margin-left: -16px;
    margin-right: -16px;
  }

  &.s-select-value {
    .s-filial-item__icon {
      svg {
        color: #FF9100;
      }
    }
  }

}
</style>
